import { useQuery } from '@tanstack/react-query';
import { Skeleton, Typography } from '@volvo/vcdk-react';
import React from 'react';

import { withComponentErrorBoundary } from '@/components/ComponentErrorBoundary';
import { getIndividualProductsQueryOptions } from '@/service/vpc/queryOptions';

type Props = {
  chassisPosition: string;
  serialNumbers: string[];
};

const ProductCategory: React.FC<Props> = ({ chassisPosition, serialNumbers }) => {
  const { data: unitsProducts, isLoading: isLoadingProducts } = useQuery(
    getIndividualProductsQueryOptions({ serialNumbers })
  );

  if (isLoadingProducts) {
    return <Skeleton variant="rounded-rectangle" height={18} width={100} />;
  }

  return (
    <Typography variant="caption1" className="text-subtle whitespace-nowrap">
      {chassisPosition
        ? `${chassisPosition} - ${unitsProducts?.map((product) => product.productCategory).join(', ')}`
        : unitsProducts?.map((product) => product.productCategory).join(', ')}
    </Typography>
  );
};

export default withComponentErrorBoundary(ProductCategory);
